<template>
<div>
    <static-map :google-api-key="apiKey" :format="format" :markers="markers" :zoom="zoom" :center="center" :type="type" :language="language" :size="size"></static-map>
</div>
</template>

<script>

import StaticMap from 'vue-static-map'

export default {
  components: {
    StaticMap
  },
  props: ['lat', 'long', 'size'],
  data () {
    return {
      apiKey: 'AIzaSyClBFD7OmQ_rOx-P8u3P9Qz0EcN5SBMf-Q', // required
      zoom: 14, // required
      center: `${this.lat},${this.long}`,
      format: 'gif',
      language: 'en',
      markers: [
        {
          color: 'primary', lat: this.lat, lng: this.long, size: 'medium'
        }
      ],
      type: 'roadmap'
    }
  }
}
</script>
